import { SxProps, Theme } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const ORDER_STATUS = {
	CANCELLED: 'Cancelada',
	PENDING_PAYMENT: 'Pendiente de Pago',
	PENDING: 'Pendiente',
	RESCHEDULED: 'Reprogramada',
	ON_THE_WAY: 'En camino',
	IN_PROGRESS: 'En proceso',
} as const;

const baseStatusStyle: SxProps<Theme> = {
	fontWeight: OpenSansFontWeights.semibold,
};

const highlightedStatusStyle: SxProps<Theme> = {
	...baseStatusStyle,
	border: '3px !important',
	py: '2px',
	px: '8px',
};

export const recentOrdersStatusSx = (status: string): SxProps<Theme> => {
	switch (status) {
		case ORDER_STATUS.CANCELLED:
			return {
				...baseStatusStyle,
				background: 'none',
				color: (theme) => theme.palette.grey[300],
			};

		case ORDER_STATUS.PENDING_PAYMENT:
		case ORDER_STATUS.PENDING:
			return {
				...highlightedStatusStyle,
				background: (theme) => theme.palette.error.main,
				color: (theme) => theme.palette.background.paper,
			};

		case ORDER_STATUS.RESCHEDULED:
			return {
				...highlightedStatusStyle,
				backgroundColor: 'alert.light',
				color: 'alert.main',
			};

		case ORDER_STATUS.ON_THE_WAY:
		case ORDER_STATUS.IN_PROGRESS:
			return {
				...baseStatusStyle,
				backgroundColor: 'none',
				color: 'success.main',
			};

		default:
			return {
				...baseStatusStyle,
				background: 'none',
				color: (theme) => theme.palette.grey[500],
			};
	}
};
